import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { useAuthStore } from './store/authStore';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import ProjectEditor from './pages/ProjectEditor';
import AdminPanel from './pages/AdminPanel';
import BillingDashboard from './pages/BillingDashboard';
import BillingAdminPanel from './pages/admin/BillingAdminPanel';
import AdminAnalyticsDashboard from './pages/admin/AdminAnalyticsDashboard';
import Layout from './components/Layout';

function PrivateRoute({ children, adminOnly = false }) {
  const { user, isAuthenticated } = useAuthStore();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && user?.Role !== 'ADMIN') {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          
          <Route path="/" element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="projects/:id" element={<ProjectEditor />} />
            <Route path="billing" element={<BillingDashboard />} />
            <Route path="admin" element={
              <PrivateRoute adminOnly>
                <AdminPanel />
              </PrivateRoute>
            } />
            <Route path="admin/billing" element={
              <PrivateRoute adminOnly>
                <BillingAdminPanel />
              </PrivateRoute>
            } />
            <Route path="admin/analytics" element={
              <PrivateRoute adminOnly>
                <AdminAnalyticsDashboard />
              </PrivateRoute>
            } />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </>
  );
}

export default App;
